import { Link } from "react-router-dom";
import "./Terms&Conditions.css"
import { BiCategoryAlt } from "react-icons/bi";
import { IoSearchOutline } from "react-icons/io5";
import { MdOutlineAccountCircle } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { IoHome } from "react-icons/io5";
import { AiOutlineDoubleRight } from "react-icons/ai";
const TermsConditions = () => {
    return (
        <>
            <div class="tf-page-title">
                <div class="row">
                    <div class="col-12">
                        <div class="heading text-center ">
                            <h4 className='breadcrumbtitle'>Terms & Conditions</h4>
                            <div className=' breadcrumb'>
                                <Link to="/" style={{ color: "black" }} ><h6>Home</h6></Link><AiOutlineDoubleRight size={20} style={{ marginTop: "0.5vh" }} />
                                <h6>Terms & Conditions</h6></div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="container">
                <div class="m-page-content rte m-scroll-trigger animate--fade-in-up">
                    <div class="static_pages">
                        <div data-message-author-role="assistant" data-message-id="50c9a216-f19a-41a4-9b50-24f6b09ed0bf" class="min-h-[20px] text-message flex flex-col items-start gap-3 whitespace-pre-wrap break-words [.text-message+&amp;]:mt-5 overflow-x-auto">
                            <div class="markdown prose w-full break-words dark:prose-invert light">
                                <p>Welcome to RoyalHood Proprietary. By accessing or using our services, you agree to comply with and be bound by these Terms and Conditions.</p>
                                
                            </div>
                        </div><br/>
                        <div class="w-full pt-2 md:pt-0 dark:border-white/20 md:border-transparent md:dark:border-transparent md:w-[calc(100%-.5rem)]"><form class="stretch flex flex-row gap-3 last:mb-2 md:mx-4 md:last:mb-6 lg:mx-auto lg:max-w-2xl xl:max-w-3xl">
                            <div class="relative flex h-full flex-1 items-stretch md:flex-col">
                               
                                <div class="span"><b>Definitions</b></div>
                            </div>
                        </form></div><br/>
                        <ul>
                            <li>User: Anyone who accesses our website or uses our services.</li>
                            <li>Service: The rental services offered through our website.</li>
                            <li>Personal Data: Information as defined by GDPR.</li>
                        </ul><br/>
                        <p>Eligibility Users must be at least 13 and legally capable of entering into binding agreements.</p>
                        <br /><div class="span"><b>User Account</b></div><br />
                        <p>Users may need to create an account to access certain features.

Users are responsible for maintaining the confidentiality of their account information and ensuring its accuracy.</p>
                        <br /><div class="span"><b>Payments</b></div><br />
                        <p>All rentals must be paid in accordance with the pricing and payment terms displayed on the website.

We use GDPR-compliant third-party payment processors.</p>
                        <br /><div class="span"><b>Use of Services</b></div><br />
                        <p>Users agree to use our services in compliance with applicable laws.

Unauthorized or fraudulent activity is prohibited.</p>
                        <br /><div class="span"><b>GDPR Compliance</b></div><br />
                        <p>We process personal data as described in our Privacy Policy, which complies with GDPR regulations.

Users have rights regarding their data, including access, correction, erasure, and objection.</p>
                        <br />
                        {/* <br/><div class="span"><b>Late Fees</b></div><br/>
                        <p>A $25 late fee will be charged if dresses are not shipped back on time, calculated as the finishing of your rental duration plus shipping time (2-7 days) plus 1 day.</p> */}
                        
                        <p>Intellectual Property All content on the website, including text, graphics, and trademarks, is the property of RoyalHood Proprietary and may not be used without our permission.</p><br/>
                        <div class="span"><b>Liability</b></div><br />
                        <p>We are not liable for damages resulting from the use of our services, except as provided by applicable law.

Users are responsible for ensuring the items rented are used appropriately.</p><br/>

<p>Termination We reserve the right to suspend or terminate user accounts for violations of these terms.</p><br/>
<p>Amendments We may update these Terms and Conditions periodically, and the updated version will be effective immediately upon publication.</p><br/>
<p>Governing Law These terms are governed by the laws of India.</p><br/>
<p>Contact Information For any questions regarding these Terms and Conditions, please contact us at +91-9620072626.</p>
                    </div>
                </div>
            </div>
            <div class="tf-toolbar-bottom type-1150">
                <div class="toolbar-item">
                    <a style={{ color: "black" }} href="/">
                        <div class="toolbar-icon">
                            <IoHome />
                        </div>
                        <div class="toolbar-label">Home</div>
                    </a>
                </div>
                <div class="toolbar-item">
                    <a style={{ color: "black" }} href="/products" >
                        <div class="toolbar-icon">
                            <BiCategoryAlt />
                        </div>
                        <div class="toolbar-label">Shop</div>
                    </a>
                </div>
                <div class="toolbar-item">
                    <a style={{ color: "black" }} href="/SearchBar" >
                        <div class="toolbar-icon">
                            <IoSearchOutline />
                        </div>
                        <div class="toolbar-label">Search</div>
                    </a>
                </div>
                <div class="toolbar-item">
                    <a style={{ color: "black" }} href="/cart">
                        <div class="toolbar-icon">
                            <FaShoppingCart />
                        </div>
                        <div class="toolbar-label">Cart</div>
                    </a>
                </div>
            </div>
        </>
    );
};
export default TermsConditions;